import React, { useState } from "react";
import { Redirect } from "react-router";
import { GlobalContext } from "../../Context/GlobalState";
import LedgerReportTable from "./LedgerReportTable";
const LedgerReport = () => {
  return (
    <GlobalContext.Consumer>
      {(context) =>
        context.user == null ? (
          <Redirect to="/" />
        ) : (
          <div style={{ margin: "10px" }}>
            {/* <div
              style={{
                display: "flex",
                background: "#30363e",
                color: "#FFF",
                padding: "10px",
                justifyContent: "space-between",
              }}
            >
              <strong>Ledger History</strong>
            </div> */}
            <LedgerReportTable />
          </div>
        )
      }
    </GlobalContext.Consumer>
  );
};

export default LedgerReport;
